const informationFunc = () => {
  const textArea = document.querySelector('.top-information__textarea');
  const accordionIcon = document.querySelector('.top-information__accordion');

  if (textArea != null && accordionIcon != null) {
    // ロード時にテキストエリアの幅を取得
    textArea.classList.add('widthCheck');
    const fullContentWidth = textArea.scrollWidth;
    textArea.classList.remove('widthCheck');

    // テキストエリアの幅がコンテンツの幅より狭い場合は省略
    if (fullContentWidth > textArea.offsetWidth) {
      textArea.classList.add('text-truncate');
      accordionIcon.classList.add('active');
    } else {
      textArea.classList.remove('text-truncate');
      accordionIcon.classList.remove('active');
    }

    // アコーディオンアイコンをクリックした時の処理
    accordionIcon.addEventListener('click', function () {
      if (textArea.classList.contains('text-truncate')) {
        textArea.classList.remove('text-truncate');
        textArea.classList.add('show-full-text');
        accordionIcon.classList.add('is-open');
      } else {
        textArea.classList.remove('show-full-text');
        textArea.classList.add('text-truncate');
        accordionIcon.classList.remove('is-open');
      }
    });
  }
};

window.addEventListener('DOMContentLoaded', informationFunc);
window.addEventListener('resize', informationFunc);
